import type { CartItem } from '../createCartItemsStore';
import { isOnProductionOnly } from '#lib/utils/env/isOnProductionOnly/isOnProductionOnly.js';

export const tagRemoveFromCart = (
	cartItem: Omit<CartItem, 'quantity'>,
	quantity: number
) => {
	if (isOnProductionOnly() && cartItem.price) {
		if (window.gtag) {
			window.gtag('event', 'remove_from_cart', {
				value: cartItem.price * quantity,
				currency: cartItem.currency,
				items: [
					{
						item_id: cartItem.entityId,
						item_name: cartItem.name,
						price: cartItem.price,
						quantity,
					},
				],
			});
		}

		if (window.twq) {
			window.twq('event', 'tw-o5kd6-of483', {
				value: cartItem.price * quantity,
				currency: cartItem.currency,
				contents: [
					{
						content_id: cartItem.entityId,
						content_name: cartItem.name,
						content_price: cartItem.price,
						num_items: quantity,
						quantity,
						content_group_id: cartItem.groupId,
					},
				],
			});
		}
	}
};
